import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { defaultPaging } from '@/common/constants/ConstCode';

const state = {
  condition: {
    ...defaultPaging
  },
  faqList: [],
  detail: ''
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
